module.exports = __webpack_public_path__ + "img/mercure.354c038b.jpg";